import UIFlex from 'UIComponents/layout/UIFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PublicViewLoading() {
  return /*#__PURE__*/_jsx(UIFlex, {
    align: "center",
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered",
      grow: true
    })
  });
}